import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { useIntl } from '@leagueplatform/locales';
import { HeaderNavLink } from '@leagueplatform/solutions-foundation';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';

export const useNavLinksList = () => {
  const { formatMessage } = useIntl();
  const navLinksList: HeaderNavLink[] = [
    {
      to: APP_MANAGED_ROUTES.HOME,
      label: formatMessage({ id: 'STR_HOME' }),
      icon: 'homeNavIcon',
    },
    {
      to: APP_MANAGED_ROUTES.APPOINTMENTS,
      label: formatMessage({ id: 'STR_APPOINTMENTS' }),
      icon: 'appointmentsNavIcon',
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.careDocuments),
      label: formatMessage({ id: 'STR_DOCUMENTS' }),
      icon: 'documentsNavIcon',
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.healthJourney),
      label: formatMessage({ id: 'STR_JOURNEY' }),
      icon: 'journeyNavIcon',
    },
  ];
  return {
    navLinks: navLinksList,
  };
};
